import React, { useState } from "react";
import styles from "./style.module.scss";
import { MutateResetAKSDashboard } from "../../../utils/graphql/hooks/adminHooks";

export default function AKSDashboardResetControls() {
  const resetAKSDashboard = MutateResetAKSDashboard();
  const [showConfirm, setShowConfirm] = useState(false);

  const handleReset = async () => {
    await resetAKSDashboard();
    setShowConfirm(false);
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>AKS Dashboard Reset</div>
      {showConfirm ? (
        <div className={styles.confirmationOverlay}>
          <div className={styles.confirmationQuestion}>
            Are you sure? This will also disconnect from V2.
          </div>
          <div className={styles.confirmationButtons}>
            <button className={styles.confirmButton} onClick={handleReset}>
              Yes
            </button>
            <button
              className={styles.confirmButton}
              onClick={() => setShowConfirm(false)}
            >
              No
            </button>
          </div>
        </div>
      ) : (
        <div className={styles.controls}>
          <button
            className={styles.actionButton}
            onClick={() => setShowConfirm(true)}
          >
            Reset AKS Dashboard
          </button>
        </div>
      )}
    </div>
  );
}
